import type { GemsApiCertificateFragment } from '@/graphql/api'
import type { ComputedRef, Ref } from 'vue'
import { computed, toValue } from 'vue'
import { GemsApi_CertificateLab } from '@/graphql/api'

export type StoneCertificate = {
    lab: string
    url: string
    number: string
}

export function toCertificate(
    stone:
        | Ref<GemsApiCertificateFragment | undefined | null>
        | (() => GemsApiCertificateFragment | undefined | null)
): ComputedRef<StoneCertificate | null> {
    return computed((): StoneCertificate | null => {
        const certs = toValue(stone)?.certificates

        if (certs?.gia) {
            return {
                lab: GemsApi_CertificateLab.Gia,
                url: `https://www.gia.edu/report-check?reportno=${certs.gia}`,
                number: certs.gia,
            }
        }

        if (certs?.igi) {
            return {
                lab: GemsApi_CertificateLab.Igi,
                url: `https://www.igi.org/reports/verify-your-report?r=${certs.igi}`,
                number: certs.igi,
            }
        }

        if (certs?.gcal) {
            return {
                lab: GemsApi_CertificateLab.Gcal,
                url: `https://www.gcalusa.com/certificate-search.html?certificate_id=${certs.gcal}`,
                number: certs.gcal,
            }
        }

        return null
    })
}
